<template>
    <v-card :color="boxClass"
            class="white--text"
            height="100%">
        <v-card-title primary-title>
            <v-container class="pa-0">
                <v-layout row
                          wrap>
                    <v-flex xs12
                            class="headline">
                        <div v-html="$t(title)"></div>
                    </v-flex>
                </v-layout>
                <v-layout row
                          wrap>
                    <v-flex xs12
                            class="text-xs-right">
                        <h1 class="white--text">{{bigTextValue}}</h1>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-title>
    </v-card>
</template>
<script>
export default {
  name: 'info-dashboard-box',
  props: ['bigTextValue', 'smallTextValue', 'title', 'maskTitle', 'classIcon', 'boxClass', 'titleClass'],
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.bg-gray {
  background-color: #b3b3b3;
  color: #fff;
}

.card__title {
  padding: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/commons/InfoDashboardBox.vue